import { Controller } from "@hotwired/stimulus"

// The twins' lines as they're said (DuetsController#lines), polled while a
// duet runs. When it stops running, the page reloads into its next state -
// the review, or what went wrong.
export default class extends Controller {
    // transcript: false just waits for the status to move on (recording).
    static values = { url: String, side: String, names: Object, transcript: { type: Boolean, default: true } }

    connect() {
        this.seen = new Set(Array.from(this.element.querySelectorAll("[id^='line-']")).map((li) => li.id))
        this.poll()
    }

    disconnect() {
        clearTimeout(this.timer)
    }

    async poll() {
        try {
            const res = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
            if (res.ok) {
                const data = await res.json()
                if (this.transcriptValue) data.lines.forEach((line) => this.add(line))
                if (!["accepted", "running", "recording"].includes(data.status)) {
                    window.Turbo ? window.Turbo.visit(window.location.href, { action: "replace" }) : window.location.reload()
                    return
                }
            }
        } catch (_) {
            // A dropped poll just tries again.
        }
        this.timer = setTimeout(() => this.poll(), 1500)
    }

    add(line) {
        const id = `line-${line.seq}`
        if (this.seen.has(id)) return
        this.seen.add(id)
        const li = document.createElement("li")
        li.id = id
        li.className = `duet-line profile-chat-line ${line.side === this.sideValue ? "profile-chat-line--asker" : "profile-chat-line--twin"}`
        const who = document.createElement("span")
        who.className = "duet-line-who"
        who.textContent = this.namesValue[line.side] || ""
        const body = document.createElement("span")
        body.className = "duet-line-body"
        body.textContent = line.body
        li.append(who, body)
        this.element.append(li)
    }
}
